import { defineRouting } from 'next-intl/routing'
import { createNavigation } from 'next-intl/navigation'

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ['en', 'de'],

  // Used when no locale matches
  defaultLocale: 'de',
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)

// Re-export additional client-side navigation hooks that aren't
// returned by createNavigation so components can import from
// `@/i18n/routing` exclusively.
// Note: client-only hooks like `useSearchParams` or
// `useSelectedLayoutSegments` are not re-exported here because
// they are client-specific and may not be available in all
// runtime contexts. Import them directly from 'next/navigation'
// in client components when needed.
